import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Footer from './Footer';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Footer 组件
 */
class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div key="footer">
                <Footer content={content.footer} />
            </div>
        );
    }
}

export default errorBoundary(BottomFooter);
